import React from 'react';
import { motion } from 'framer-motion';
import { Users, Bike, Activity, DollarSign, TrendingUp, MapPin, Clock } from 'lucide-react';
import { AreaChart, Area, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer, BarChart, Bar } from 'recharts';
import { StatsCard } from '../components/StatsCard';
import { StatusBadge } from '../components/StatusBadge';
const revenueData = [{
  name: 'Mon',
  value: 4000
}, {
  name: 'Tue',
  value: 3000
}, {
  name: 'Wed',
  value: 5000
}, {
  name: 'Thu',
  value: 2780
}, {
  name: 'Fri',
  value: 8890
}, {
  name: 'Sat',
  value: 12390
}, {
  name: 'Sun',
  value: 14280
}];
const ridesData = [{
  name: 'Mon',
  rides: 120
}, {
  name: 'Tue',
  rides: 132
}, {
  name: 'Wed',
  rides: 101
}, {
  name: 'Thu',
  rides: 134
}, {
  name: 'Fri',
  rides: 190
}, {
  name: 'Sat',
  rides: 230
}, {
  name: 'Sun',
  rides: 210
}];
const recentRides = [{
  id: 1,
  rider: 'John Doe',
  user: 'Alice Smith',
  route: 'Downtown -> Airport',
  status: 'active',
  fare: '₦45.00',
  time: '2 min ago'
}, {
  id: 2,
  rider: 'Mike Ross',
  user: 'Sarah Connor',
  route: 'Mall -> Suburbs',
  status: 'completed',
  fare: '₦22.50',
  time: '15 min ago'
}, {
  id: 3,
  rider: 'David Kim',
  user: 'Tom Hardy',
  route: 'Station -> Hotel',
  status: 'completed',
  fare: '₦18.00',
  time: '28 min ago'
}, {
  id: 4,
  rider: 'Lisa Wang',
  user: 'Bruce Wayne',
  route: 'Office -> Gym',
  status: 'cancelled',
  fare: '₦0.00',
  time: '45 min ago'
}, {
  id: 5,
  rider: 'James Bond',
  user: 'Vesper Lynd',
  route: 'Casino -> Villa',
  status: 'completed',
  fare: '₦120.00',
  time: '1 hr ago'
}];
const activities = [{
  id: 1,
  type: 'signup',
  message: 'New rider application received',
  time: '5 min ago',
  icon: Bike
}, {
  id: 2,
  type: 'payment',
  message: 'Payout batch #402 processed',
  time: '2 hours ago',
  icon: DollarSign
}, {
  id: 3,
  type: 'alert',
  message: 'High demand in Downtown area',
  time: '3 hours ago',
  icon: Activity
}, {
  id: 4,
  type: 'support',
  message: 'Ticket #2901 escalated',
  time: '4 hours ago',
  icon: Users
}];
export function DashboardOverview() {
  return <div className="space-y-6" data-id="element-232">
      {/* Stats Grid */}
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6" data-id="element-233">
        <StatsCard title="Total Riders" value="1,247" trend={12} icon={Bike} color="gold" delay={0} data-id="element-234" />
        <StatsCard title="Total Users" value="28,493" trend={8} icon={Users} color="blue" delay={0.1} data-id="element-235" />
        <StatsCard title="Active Rides" value="342" trend={24} icon={Activity} color="green" delay={0.2} data-id="element-236" />
        <StatsCard title="Today's Revenue" value="₦14,280" trend={15} icon={DollarSign} color="purple" delay={0.3} data-id="element-237" />
      </div>

      <div className="grid grid-cols-1 lg:grid-cols-3 gap-6" data-id="element-238">
        {/* Revenue Chart */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        delay: 0.4
      }} className="lg:col-span-2 bg-white p-6 rounded-xl shadow-sm border border-slate-100" data-id="element-239">
          <div className="flex justify-between items-center mb-6" data-id="element-240">
            <h3 className="text-lg font-bold text-slate-800" data-id="element-241">
              Revenue Overview
            </h3>
            <select className="bg-slate-50 border border-slate-200 rounded-lg text-sm px-3 py-1 outline-none focus:border-famo-gold" data-id="element-242">
              <option data-id="element-243">Last 7 Days</option>
              <option data-id="element-244">Last 30 Days</option>
              <option data-id="element-245">This Year</option>
            </select>
          </div>
          <div className="h-80 w-full" data-id="element-246">
            <ResponsiveContainer width="100%" height="100%" data-id="element-247">
              <AreaChart data={revenueData} data-id="element-248">
                <defs data-id="element-249">
                  <linearGradient id="colorRevenue" x1="0" y1="0" x2="0" y2="1" data-id="element-250">
                    <stop offset="5%" stopColor="#C9956B" stopOpacity={0.3} data-id="element-251" />
                    <stop offset="95%" stopColor="#C9956B" stopOpacity={0} data-id="element-252" />
                  </linearGradient>
                </defs>
                <CartesianGrid strokeDasharray="3 3" vertical={false} stroke="#E2E8F0" data-id="element-253" />
                <XAxis dataKey="name" axisLine={false} tickLine={false} tick={{
                fill: '#64748B',
                fontSize: 12
              }} dy={10} data-id="element-254" />
                <YAxis axisLine={false} tickLine={false} tick={{
                fill: '#64748B',
                fontSize: 12
              }} tickFormatter={value => `$${value}`} data-id="element-255" />
                <Tooltip contentStyle={{
                backgroundColor: '#fff',
                borderRadius: '8px',
                border: '1px solid #E2E8F0',
                boxShadow: '0 4px 6px -1px rgb(0 0 0 / 0.1)'
              }} itemStyle={{
                color: '#C9956B',
                fontWeight: 600
              }} data-id="element-256" />
                <Area type="monotone" dataKey="value" stroke="#C9956B" strokeWidth={3} fillOpacity={1} fill="url(#colorRevenue)" data-id="element-257" />
              </AreaChart>
            </ResponsiveContainer>
          </div>
        </motion.div>

        {/* Rides Bar Chart */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        delay: 0.5
      }} className="bg-white p-6 rounded-xl shadow-sm border border-slate-100" data-id="element-258">
          <h3 className="text-lg font-bold text-slate-800 mb-6" data-id="element-259">
            Rides per Day
          </h3>
          <div className="h-80 w-full" data-id="element-260">
            <ResponsiveContainer width="100%" height="100%" data-id="element-261">
              <BarChart data={ridesData} data-id="element-262">
                <CartesianGrid strokeDasharray="3 3" vertical={false} stroke="#E2E8F0" data-id="element-263" />
                <XAxis dataKey="name" axisLine={false} tickLine={false} tick={{
                fill: '#64748B',
                fontSize: 12
              }} dy={10} data-id="element-264" />
                <Tooltip cursor={{
                fill: '#F1F5F9'
              }} contentStyle={{
                backgroundColor: '#fff',
                borderRadius: '8px',
                border: '1px solid #E2E8F0'
              }} data-id="element-265" />
                <Bar dataKey="rides" fill="#0C1222" radius={[4, 4, 0, 0]} barSize={30} data-id="element-266" />
              </BarChart>
            </ResponsiveContainer>
          </div>
        </motion.div>
      </div>

      <div className="grid grid-cols-1 lg:grid-cols-3 gap-6" data-id="element-267">
        {/* Recent Rides Table */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        delay: 0.6
      }} className="lg:col-span-2 bg-white rounded-xl shadow-sm border border-slate-100 overflow-hidden" data-id="element-268">
          <div className="p-6 border-b border-slate-100 flex justify-between items-center" data-id="element-269">
            <h3 className="text-lg font-bold text-slate-800" data-id="element-270">Live Rides</h3>
            <button className="text-sm text-famo-gold font-medium hover:text-famo-gold-dark" data-id="element-271">
              View All
            </button>
          </div>
          <div className="overflow-x-auto" data-id="element-272">
            <table className="w-full text-left" data-id="element-273">
              <thead className="bg-slate-50" data-id="element-274">
                <tr data-id="element-275">
                  <th className="px-6 py-3 text-xs font-semibold text-slate-500 uppercase" data-id="element-276">
                    Rider
                  </th>
                  <th className="px-6 py-3 text-xs font-semibold text-slate-500 uppercase" data-id="element-277">
                    Route
                  </th>
                  <th className="px-6 py-3 text-xs font-semibold text-slate-500 uppercase" data-id="element-278">
                    Status
                  </th>
                  <th className="px-6 py-3 text-xs font-semibold text-slate-500 uppercase text-right" data-id="element-279">
                    Fare
                  </th>
                </tr>
              </thead>
              <tbody className="divide-y divide-slate-100" data-id="element-280">
                {recentRides.map(ride => <tr key={ride.id} className="hover:bg-slate-50/50 transition-colors" data-id="element-281">
                    <td className="px-6 py-4" data-id="element-282">
                      <div className="flex items-center gap-3" data-id="element-283">
                        <div className="w-8 h-8 rounded-full bg-slate-200 flex items-center justify-center text-xs font-bold text-slate-600" data-id="element-284">
                          {ride.rider.charAt(0)}
                        </div>
                        <div data-id="element-285">
                          <p className="text-sm font-medium text-slate-900" data-id="element-286">
                            {ride.rider}
                          </p>
                          <p className="text-xs text-slate-500" data-id="element-287">{ride.time}</p>
                        </div>
                      </div>
                    </td>
                    <td className="px-6 py-4" data-id="element-288">
                      <div className="flex items-center gap-2 text-sm text-slate-600" data-id="element-289">
                        <MapPin size={14} className="text-slate-400" data-id="element-290" />
                        {ride.route}
                      </div>
                    </td>
                    <td className="px-6 py-4" data-id="element-291">
                      <StatusBadge status={ride.status} data-id="element-292" />
                    </td>
                    <td className="px-6 py-4 text-right text-sm font-medium text-slate-900" data-id="element-293">
                      {ride.fare}
                    </td>
                  </tr>)}
              </tbody>
            </table>
          </div>
        </motion.div>

        {/* Activity Feed */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        delay: 0.7
      }} className="bg-white rounded-xl shadow-sm border border-slate-100 p-6" data-id="element-294">
          <h3 className="text-lg font-bold text-slate-800 mb-6" data-id="element-295">
            Recent Activity
          </h3>
          <div className="space-y-6" data-id="element-296">
            {activities.map((activity, idx) => {
            const Icon = activity.icon;
            return <div key={activity.id} className="flex gap-4 relative" data-id="element-297">
                  {idx !== activities.length - 1 && <div className="absolute left-[15px] top-8 bottom-[-24px] w-0.5 bg-slate-100" data-id="element-298"></div>}
                  <div className="w-8 h-8 rounded-full bg-slate-50 border border-slate-200 flex items-center justify-center flex-shrink-0 z-10" data-id="element-299">
                    <Icon size={14} className="text-slate-500" data-id="element-300" />
                  </div>
                  <div data-id="element-301">
                    <p className="text-sm text-slate-800 font-medium" data-id="element-302">
                      {activity.message}
                    </p>
                    <p className="text-xs text-slate-500 mt-1 flex items-center gap-1" data-id="element-303">
                      <Clock size={12} data-id="element-304" />
                      {activity.time}
                    </p>
                  </div>
                </div>;
          })}
          </div>
        </motion.div>
      </div>
    </div>;
}